import { useEffect } from "react"
import { useLocation } from "react-router-dom"

// Scroll to the element named by the URL hash (e.g. /#services or
// /business-integrations#ai-chatbots). ScrollToTop skips URLs with a hash.
// `key` changes on every navigation, so repeat clicks on the same anchor work.
export default function useHashScroll() {
  const { hash, key } = useLocation()

  useEffect(() => {
    if (!hash) return
    const target = document.getElementById(decodeURIComponent(hash.slice(1)))
    if (!target) return
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    target.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" })
  }, [hash, key])
}
